import React, { useEffect, useState } from 'react';
import Uppy from '@uppy/core';
import { Dashboard } from '@uppy/react';
import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import { useTranslation } from 'react-i18next';
const FileUploader = /*#__PURE__*/React.memo(_ref => {
  let {
    onSelectFile,
    setUppyInstance,
    onUserEditFileStart,
    onUserEditFileEnd,
    isAddingFilesDisabled
  } = _ref;
  const {
    t
  } = useTranslation();
  const [uppy, setUppy] = useState(null);
  const restrictions = {
    maxFileSize: 2 * 1024 * 1024 * 1024,
    allowedFileTypes: null
  };
  useEffect(() => {
    if (uppy && isAddingFilesDisabled) {
      const count = uppy.getFiles().length;
      uppy.setOptions({
        restrictions: {
          ...restrictions,
          maxNumberOfFiles: count
        }
      });
    }
  }, [isAddingFilesDisabled, uppy]);
  useEffect(() => {
    const uppyInstance = new Uppy({
      restrictions,
      autoProceed: false,
      debug: false,
      allowMultipleUploads: true
    });
    uppyInstance.on('file-added', onSelectFile);
    uppyInstance.on('manual-progress-update', (file, percentage) => {
      const files = {
        ...uppyInstance.getState().files
      };
      if (!files[file.id]) return;
      files[file.id] = {
        ...files[file.id],
        progress: {
          ...files[file.id].progress,
          uploadStarted: true,
          uploadComplete: false,
          percentage
        }
      };
      uppyInstance.setState({
        files
      });
    });
    uppyInstance.on('upload-success', (file, response) => {
      const files = {
        ...uppyInstance.getState().files
      };
      files[file.id] = {
        ...files[file.id],
        progress: {
          uploadComplete: true,
          percentage: 100
        }
      };
      uppyInstance.setState({
        files
      });
    });
    uppyInstance.on('upload-error', (file, error) => {
      const files = {
        ...uppyInstance.getState().files
      };
      if (files[file.id]) files[file.id].error = error.message || 'Upload error';
      uppyInstance.setState({
        files
      });
    });
    uppyInstance.on('complete', result => {
      console.info('All uploads complete. Successful:', result.successful.map(f => f.name), 'Failed:', result.failed.map(f => f.name));
    });
    uppyInstance.on('dashboard:file-edit-start', onUserEditFileStart);
    uppyInstance.on('dashboard:file-edit-complete', onUserEditFileEnd);
    uppyInstance.on('file-meta-updated', file => {
      const newName = file.meta.name;
      if (newName && newName !== file.name) {
        uppyInstance.setFileState(file.id, {
          name: newName
        });
      }
    });
    setUppy(uppyInstance);
    if (setUppyInstance) setUppyInstance(uppyInstance);
    return () => {
      uppyInstance.cancelAll();
    };
  }, [onSelectFile, onUserEditFileStart, onUserEditFileEnd, setUppyInstance]);
  if (!uppy) return null;
  return /*#__PURE__*/React.createElement(Dashboard, {
    uppy: uppy,
    proudlyDisplayPoweredByUppy: false,
    showProgressDetails: true,
    hideUploadButton: true,
    width: "100%",
    height: "400px",
    theme: "auto",
    metaFields: [{
      id: 'name',
      name: t('name'),
      placeholder: t('Enter file name')
    }]
  });
});
export default FileUploader;